import React, { useEffect, useRef, useState } from "react";
import "../layout/layout.css";
import * as apicall from "../../components/Apicall";
import { toast } from "react-toastify";
import { Formik, FieldArray } from "formik";
import * as Yup from "yup";
import { FaArrowLeft } from "react-icons/fa";
import { MdAttachFile, MdDelete } from "react-icons/md";
import { useLocation, useNavigate } from "react-router-dom";
import RFQLayout from "./RFQlayout";
import RFQActivityLog from "./RFQActivity";

const RFQSchema = Yup.object().shape({
  title: Yup.string().required("RFQ Title is required"),
  items: Yup.array().of(
    Yup.object().shape({
      category: Yup.string().required("Please select a category"),
      itemName: Yup.string().required("Item name is required"),
      brand: Yup.string(),
      quantity: Yup.number()
        .typeError("Quantity must be a number")
        .positive("Quantity must be greater than zero")
        .required("Quantity is required"),
      description: Yup.string(),
      // estimatedPrice: Yup.number()
      //   .typeError("Estimated Price must be a number")
      //   .required("Estimated Price is required"),
      parameters1: Yup.array().of(
        Yup.object().shape({
          key: Yup.string().required("Parameter Name is required"),
          value: Yup.string().required("Parameter Value is required"),
        })
      ),
    })
  ),
});

const CreateRFQ = ({ onNext, onCancel }) => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
const fileInputRefs = useRef([]);
 const location = useLocation();
  const navigate = useNavigate();

  const initialData = location.state?.formData || null;
  const mode = location.state?.mode || "add";
  const rfqStatus = initialData?.RFQ_Data?.[0]?.status;
const isDraft = rfqStatus === "0";
  const userDetails = JSON.parse(localStorage.getItem("user_details"));

const isViewMode = mode === "view";
const isEditMode = mode === "edit";
const isAddMode = mode === "add";
console.log(mode,"mode")
  const getProductList = async () => {
    setLoading(true);
    try {
      const res = await apicall.get("get_products");
      setProducts(res.data || []);
    } catch (e) {
      toast.error(e.message.replace("Error:", ""));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getProductList();
  }, []);

const handleImageChange = (e, index, formik) => {
  const files = Array.from(e.target.files);
  if (!files.length) return;

  files.forEach((file) => {
    const fileData = {
      fileType: file.type,
      fileName: file.name,
      preview: "",
      isExisting: false,
    };

    const reader = new FileReader();
    reader.onload = () => {
      fileData.preview = reader.result;

      const existingFiles = formik.values.items[index].files || [];
      formik.setFieldValue(
        `items.${index}.files`,
        [...existingFiles, fileData]
      );
    };

    reader.readAsDataURL(file);
  });
};

const mapBackendToForm1 = (data, products) => {
  return {
    title: data?.title || "",
    items: (data?.RFQ_Data || [])?.map((item) => {
      // Find the product in products array by name
      const matchedProduct = products?.find(
        (p) => p.name.toLowerCase() === (item.product_name || "").toLowerCase()
      );

      return {
        link_id: item.id,
        category: matchedProduct ? matchedProduct.id : "",
        itemName: item.item || "",
        brand: item.brand || "",
        quantity: item.quantity || "",
        description: item.description || "",
        estimatedPrice: item.price || "",
        parameters1: item.params
          ? Object.entries(JSON.parse(item.params)).map(([key, value]) => ({
              key,
              value,
            }))
          : [],
        files: item.documents
  ? [
      {
        fileType: item.documents.match(/\.(jpg|jpeg|png)$/i)
          ? "image/*"
          : "application/pdf",
        fileName: item.documents.split("/").pop(),
        preview: `${process.env.REACT_APP_FILE_BASE_URL}/${item.documents}`,
        isExisting: true, 
      },
    ]
  : [],

      };
    }),
  };
};
const safeParseJSON = (str) => {
  if (!str) return {};
  try {
    return JSON.parse(str);
  } catch (e) {
    console.warn("Invalid JSON, using empty object:", str);
    return {}; // fallback to empty object for drafts
  }
};

const [initialValues, setInitialValues] = useState({
  title: "",
  items: [
    {
      category: "",
      itemName: "",
      brand: "",
      quantity: "",
      description: "",
      estimatedPrice: "",
      parameters1: [],
      files: [],
    },
  ],
});

useEffect(() => {
  if (!products.length || !initialData) return;

  const mappedItems = (initialData.items || initialData.RFQ_Data || []).map((item) => {
    const matchedProduct = products.find(
      (p) => p.name.toLowerCase() === (item.product_name || item.itemName || "").toLowerCase()
    );

    // Normalize documents/files
    let documentsArray = [];

    if (item.files && item.files.length) {
      documentsArray = item.files;
    } else if (item.documents) {
      const docs = Array.isArray(item.documents) ? item.documents : [item.documents];

      documentsArray = docs.map((doc) => {
        if (typeof doc === "string") {
          // Extract filename from URL
          const fileName = doc.split("/").pop();
          // Determine type by extension
          const fileType = fileName.match(/\.(jpg|jpeg|png)$/i) ? "image/*" : "application/pdf";

          return {
            fileType,
            fileName,
            preview: doc, // use URL directly
            isExisting: true,
          };
        } else if (typeof doc === "object") {
          // Already a file object
          return { ...doc, isExisting: true };
        }
        return null;
      }).filter(Boolean); // remove nulls
    }

    return {
      ...item,
      category: matchedProduct ? matchedProduct.id : item.category || "",
      product_name: matchedProduct ? matchedProduct.name : item.product_name || item.itemName || "",
      itemName: item.itemName || item.item || "",
      brand: item.brand || "",
      quantity: item.quantity || "",
      description: item.description || "",
      estimatedPrice: item.estimatedPrice || item.price || "",
      parameters1: item.params
        ? Object.entries(safeParseJSON(item.params)).map(([key, value]) => ({ key, value }))
        : item.parameters1 || [],
      files: documentsArray,
    };
  });

  setInitialValues({
    title: initialData.title || "",
    items: mappedItems.length
      ? mappedItems
      : [
          {
            category: "",
            itemName: "",
            brand: "",
            quantity: "",
            description: "",
            estimatedPrice: "",
            parameters1: [],
            files: [],
          },
        ],
  });
}, [products, initialData]);


  return (
        <RFQLayout rfqId={initialData?.id}
        userDetails={userDetails}
        >

     <Formik
  initialValues={initialValues}
  validationSchema={RFQSchema}
  enableReinitialize
 onSubmit={(values) => {
  // Use values from Formik
  const itemsWithName = values.items.map((item) => {
    const matchedProduct = products.find((p) => p.id === item.category);
    return {
      ...item,
      product_name: matchedProduct ? matchedProduct.name : item.product_name || "",
       files: item.files || [],
    };
  });

  navigate("/rfq2", {
    state: {
      mode,
      formData: {
        ...initialData,
        ...values,   // ✅ use values, not formik.values
        items: itemsWithName,
      },
    },
  });
}}

>


      {(formik) => (
        <form onSubmit={formik.handleSubmit} className="rfq-container">
          <h3>

{/* <h3>
  <FaArrowLeft
    className="me-2 cursor-pointer"
    size={20}
    onClick={() => navigate("/dashboard")}
  />
  {mode === "edit" ? "Edit RFQ" : mode === "view" ? "View Details" : "Create RFQ"}
</h3>
          <h6 style={{marginLeft:"30px"}}>
  {(mode === "edit" || mode === "view") && initialData?.display_id}
</h6> */}

          </h3>

          <div className="rfq-card">
            <h4>RFQ Information</h4>
            <p>Provide basic information about your request</p>

            {/* RFQ Title */}
            <div className="mb-3">
              <label className="label mb-1">RFQ Title</label>
              <input
                type="text"
                name="title"
                className="form-control"
                placeholder="Enter a title"
                value={formik.values.title}
                disabled={mode==="view"}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              {formik.touched.title && formik.errors.title && (
                <div className="invalid-feedback d-block mt-1">
                  {formik.errors.title}
                </div>
              )}
            </div>

            <FieldArray name="items">
              {({ push, remove }) => (
                <div>
                  {formik.values.items.map((item, index) => (
 <div key={index} className="border p-3 mb-4 rounded">
                      <div className="d-flex justify-content-between align-items-center mb-2">
  <h4 className="mb-0">Item #{index + 1}</h4>
{!isViewMode && !isEditMode && formik.values.items.length > 1 && (
    <button
      type="button"
      className="btn btn-sm btn-outline-danger"
      onClick={() => remove(index)}
    >
      <MdDelete />
    </button>
  )}
</div>

                      <div className="form-row grid grid-cols-1 md:grid-cols-4 gap-4">


                        {/* Category */}
      <div>
        <label className="label mb-1">Product Category</label>
<select
disabled={mode==="view"}
  name={`items.${index}.category`}
  className="form-select"
  value={formik.values.items[index].category}
  onChange={formik.handleChange}
  onBlur={formik.handleBlur}
>
  <option value="">Select</option>
  {products.map((product) => (
    <option key={product.id} value={product.id}>
      {product.name}
    </option>
  ))}
</select>



        {formik.touched.items?.[index]?.category &&
          formik.errors.items?.[index]?.category && (
            <div className="invalid-feedback d-block mt-1">
              {formik.errors.items[index].category}
            </div>
          )}
      </div>


                        {/* Item Name */}
                        <div>
                          <label className="label mb-1">Item Name</label>
                          <input
                          disabled={mode==="view"}
                            type="text"
                            name={`items.${index}.itemName`}
                            className="form-control"
                            placeholder="Item Name"
                            value={item.itemName}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                          />
                          {formik.touched.items?.[index]?.itemName &&
                            formik.errors.items?.[index]?.itemName && (
                              <div className="invalid-feedback d-block mt-1">
                                {formik.errors.items[index].itemName}
                              </div>
                            )}
                        </div>

                        {/* Brand */}
                        <div>
                          <label className="label mb-1">Brand (optional)</label>
                          <input
                          disabled={mode==="view"}
                            type="text"
                            name={`items.${index}.brand`}
                            className="form-control"
                            placeholder="Preferred Brand"
                            value={item.brand}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                          />
                        </div>

                        {/* Quantity */}
                        <div>
                          <label className="label mb-1">Quantity</label>
                          <input
                          disabled={mode==="view"}
                            type="number"
                            name={`items.${index}.quantity`}
                            className="form-control"
                            placeholder="Enter Quantity"
                            value={item.quantity}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                          />
                          {formik.touched.items?.[index]?.quantity &&
                            formik.errors.items?.[index]?.quantity && (
                              <div className="invalid-feedback d-block mt-1">
                                {formik.errors.items[index].quantity}
                              </div>
                            )}
                        </div>

                        {/* Estimated Price */}
                        <div>
                          <label className="label mb-1">Estimated Price</label>
                          <input
                          disabled={mode==="view"}
                            type="text"
                            name={`items.${index}.estimatedPrice`}
                            className="form-control"
                            placeholder="Enter Estimated Price"
                            value={item.estimatedPrice}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                          />
                          {formik.touched.items?.[index]?.estimatedPrice &&
                            formik.errors.items?.[index]?.estimatedPrice && (
                              <div className="invalid-feedback d-block mt-1">
                                {formik.errors.items[index].estimatedPrice}
                              </div>
                            )}
                        </div>
                      </div>

                      {/* Parameters */}
                      <FieldArray name={`items.${index}.parameters1`}>
                        {({ push, remove }) => (
                            <div className="mt-3 col-span-4">
                            <button
                            disabled={mode==="view"}
                              type="button"
                              className="add-param mt-2"
                              onClick={() => push({ key: "", value: "" })}
                            >
                              + Add Parameter
                            </button>

                            {item.parameters1?.map((param, pIndex) => (
                              <div key={pIndex} className="row align-items-center mt-2">
  <div className="col-3">
    <input
    disabled={mode==="view"}
      type="text"
      name={`items.${index}.parameters1.${pIndex}.key`}
      className="form-control"
      placeholder="Parameter Name"
      value={param.key}
      onChange={formik.handleChange}
    />
  </div>

  <div className="col-3">
    <input
    disabled={mode==="view"}
      type="text"
      name={`items.${index}.parameters1.${pIndex}.value`}
      className="form-control"
      placeholder="Parameter Value"
      value={param.value}
      onChange={formik.handleChange}
    />
  </div>

  <div className="col-1 text-center">
    <button
    disabled={mode==="view"}
      type="button"
      onClick={() => remove(pIndex)}
      className="btn"
      style={{border:"1px solid black"}}
    >
      ❌
    </button>
  </div>
</div>

                            ))}
                          </div>
                        )}
                      </FieldArray>

                      {/* Description */}
                      <div className="mt-3">
                        <label className="label mb-1">Description</label>
                        <textarea
                        disabled={mode==="view"}
                          name={`items.${index}.description`}
                          className="form-control"
                          placeholder="Provide details about your requirements"
                          value={item.description}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        />
                      </div>

                     <div className="mb-3 mt-4">
  <label className="label mb-1">Upload document (optional)</label>

  <div>
    <button
      disabled={mode === "view"}
      type="button"
      className="btn btn-outline-secondary"
      onClick={() => fileInputRefs.current[index]?.click()}
    >
      <MdAttachFile /> Attach Document
    </button>

    <input
      type="file"
      accept="image/*,.pdf,.doc,.docx"
      multiple
      disabled={mode === "view"}
      ref={(el) => (fileInputRefs.current[index] = el)}
      style={{ display: "none" }}
      onChange={(e) => handleImageChange(e, index, formik)}
    />

 <div className="mt-2 d-flex flex-wrap">
  {item?.files?.map((fileItem, idx) => (
    <div
      key={idx}
      className="d-flex flex-column align-items-center me-3 mb-2"
      style={{ width: "120px" }}
    >
      {fileItem.fileType.startsWith("image/") ? (
        <img
          src={fileItem.preview}
          alt={fileItem.fileName}
          style={{ width: "100px", height: "100px", objectFit: "cover", cursor: "pointer" }}
          onClick={() => window.open(fileItem.preview, "_blank")}
        />
      ) : fileItem.fileType === "application/pdf" ? (
        <div
          style={{
            width: "100px",
            height: "100px",
            border: "1px solid #ccc",
            cursor: "pointer",
            position: "relative",
          }}
          onClick={() => window.open(fileItem.preview, "_blank")}
        >
          <embed
            src={fileItem.preview}
            type="application/pdf"
            width="100%"
            height="100%"
            style={{ pointerEvents: "none" }} // disables interaction inside preview
          />
        </div>
      ) : (
        <a href={fileItem.preview} target="_blank" rel="noopener noreferrer">
          {fileItem.fileName}
        </a>
      )}

      <button
        disabled={mode === "view"}
        type="button"
        className="btn btn-outline-danger btn-sm mt-1"
        onClick={() => {
          const newFiles = item.files.filter((_, i) => i !== idx);
          formik.setFieldValue(`items.${index}.files`, newFiles);
        }}
      >
        <MdDelete />
      </button>
    </div>
  ))}
</div>


  </div>
</div>

                    </div>
                  ))}

                  <button
                    type="button"
  disabled={mode === "view"}
                      onClick={() => {
    const lastItem = formik.values.items[formik.values.items.length - 1];
    push({
      category: lastItem?.category || "", 
      itemName: "",
      brand: "",
      quantity: "",
      description: "",
      estimatedPrice: "",
      parameters1: [],
      files: [],
    });
  }}
                    className="mt-2 text-green-600 font-semibold"
                  >
                    + Add Another Item
                  </button>
                </div>
              )}
            </FieldArray>

            {/* Actions */}

            <div className="rfq-actions flex justify-between mt-4">
                    {isViewMode && isEditMode  && (
                      
              <button type="button" className="draft-btn">
                Save as Draft
              </button>
                    )}
{(isViewMode || isEditMode || isAddMode) && (
  <button
    type="submit"
    className="continue-btn"
    disabled={formik.isSubmitting}
  >
    {isViewMode ? "Next" : "Continue to Vendor"}
  </button>
)}


            </div>
          </div>
        </form>
      )}
    </Formik>
  </RFQLayout>
 
  );
};

export default CreateRFQ;
